import React, {Component} from 'react'
import HomePage from './HomePage'
import '../styles/index.scss'
import queryString from "query-string"

class HomePageContainer extends Component {
    render() {
        const {location} = this.props.history
        let params = {}

        if (location.search !== '') {
            params = queryString.parse(location.search)
        }

        return (
            <div className='HomePageContainer'>
                <HomePage {...params}/>
            </div>
        )
    }
}

export default HomePageContainer
